module.exports = __webpack_public_path__ + "static/06-a83e032dd9f19221451cab4ca22e2159.png";